
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.879 12.667H12.39l1.805 1.805.943-.943L1.805.195l-.943.943.871.872c-.6.079-1.066.641-1.066 1.323v8c0 .737.542 1.334 1.212 1.334zM2 3.333h1.057l2 2H2v-2zm4.39 3.334H2v4.666h9.057L6.39 6.667zM5.476 2L6.81 3.333H14v2H8.81l1.333 1.334H14v3.857l1.262 1.262a1.45 1.45 0 00.071-.453v-8c0-.736-.542-1.333-1.212-1.333H5.476z"}})])
          )
        }
      }
    